module.exports = __webpack_public_path__ + "img/17.4505b415.png";